import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled from "styled-components";
import { Button, Text } from "~/components-shared";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import SignUpMemberForm from "~/forms/SignUpMemberForm";
import signUpMemberSchema from "~/forms/SignUpMemberForm/signUpMemberSchema";
const Form = styled.form`
  width: 100%;
`;
const SignUpMember = _ref => {
  let {
    isLoading,
    onSubmit,
    ...rest
  } = _ref;
  const {
    t
  } = useTranslation();
  const defaultValues = {
    firstName: "",
    lastName: "",
    password: "",
    repeatPassword: ""
  };
  const {
    handleSubmit,
    control,
    watch
  } = useForm({
    resolver: yupResolver(signUpMemberSchema),
    defaultValues
  });
  const handleSubmitClick = handleSubmit(data => {
    onSubmit(data);
  });
  return /*#__PURE__*/React.createElement(Form, _extends({
    onSubmit: handleSubmitClick
  }, rest), /*#__PURE__*/React.createElement(Text, {
    fontSize: 4,
    lineHeight: 6,
    s: {
      mb: 4
    },
    align: "center",
    display: "block"
  }, t("SignUpMember.info")), /*#__PURE__*/React.createElement(SignUpMemberForm, {
    control: control,
    watch: watch
  }), /*#__PURE__*/React.createElement(Button, {
    loading: isLoading,
    fullWidth: true,
    s: {
      mb: 4,
      mt: 4
    },
    onClick: handleSubmitClick
  }, t("SignUpMember.verifyEmail")));
};
export default SignUpMember;